import React from 'react';

import {CustomTagFilter, FILTER_KEY_TO_OPERATORS, Operator} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import TwoInputWithOperatorFilterForm from './base/TwoInputWithOperatorFilterForm';

interface Props extends BaseFilterFormProps {
  filter: CustomTagFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: CustomTagFilter) => void;
  onEnter?: () => void;
  onRemove?: () => void;
}

export default function CustomTagFilterForm(props: Props): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <TwoInputWithOperatorFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      onChangeValueOne={(name: string) => {
        props.onChangeFilter({...props.filter, name});
      }}
      onChangeValueTwo={(value: string) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onEnter={props.onEnter}
      onRemove={props.onRemove}
      valueOnePlaceholder="Field Name"
      valueTwoPlaceholder="Value"
      initialValueOne={props.filter.name || ''}
      initialValueTwo={props.filter.value || ''}
      operators={FILTER_KEY_TO_OPERATORS[props.filter.key]}
      selectedOperator={props.filter.operator}
      onChangeOperator={(operator: Operator) => {
        props.onChangeFilter({...props.filter, operator});
      }}
    />
  );
}
